/** One screen of an App, irrespective of the App's framework or data model.
 * The host resolves the source reference to live UI. This is a projection,
 * never an alternative copy of the App's implementation. */
import { GfxCompatible, type GfxCompatibleProps } from '@blocksuite/std/gfx';
import {
  BlockModel,
  BlockSchemaExtension,
  defineBlockSchema,
} from '@blocksuite/store';

export type AppScreenBlockProps = GfxCompatibleProps & {
  visible: boolean;
  appId: string;
  component: string;
  routePath: string;
  title: string;
};
export class AppScreenBlockModel extends GfxCompatible<AppScreenBlockProps>(
  BlockModel
) {}
export const AppScreenBlockSchema = defineBlockSchema({
  flavour: 'affine:app-screen',
  props: (): AppScreenBlockProps => ({
    visible: true,
    appId: '',
    component: '',
    routePath: '',
    title: '',
    xywh: '[0,0,280,600]',
    index: 'a0',
    lockedBySelf: true,
  }),
  metadata: {
    role: 'content',
    version: 1,
    parent: ['affine:surface'],
    children: [],
  },
  toModel: () => new AppScreenBlockModel(),
});
export const AppScreenBlockSchemaExtension =
  BlockSchemaExtension(AppScreenBlockSchema);
